<div class="avatar-container" [ngClass]="sizeClass" [class.is-editable]="editable">
  <!-- Show image if path exists and no error -->
  <img
    *ngIf="!imageError && photoPath"
    [src]="photoPath"
    (error)="onImageError()"
    [ngClass]="sizeClass"
    alt="{{ userName }}"
    loading="lazy"
  />

  <!-- Show initials fallback if no photo or error -->
  <div
    *ngIf="imageError || !photoPath"
    class="avatar-initials"
    [ngClass]="sizeClass"
    [style.background-color]="backgroundColor"
    [attr.aria-label]="userName"
  >
    {{ initials }}
  </div>

  <!-- Camera badge when editable -->
  <div
    *ngIf="editable"
    class="avatar-camera-badge"
    [attr.aria-label]="'USERMENU.PHOTO_MENU.CHANGE_PHOTO' | translate"
    [matTooltip]="'USERMENU.PHOTO_MENU.CHANGE_PHOTO' | translate"
  >
    <mat-icon>photo_camera</mat-icon>
  </div>

  <!-- Hover overlay on desktop when editable -->
  <div *ngIf="editable" class="avatar-hover-overlay">
    <mat-icon>photo_camera</mat-icon>
    <span class="hover-text">{{ 'USERMENU.PHOTO_MENU.CHANGE' | translate }}</span>
  </div>
</div>
